import { GridItem, IconButton, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { Trash } from "@phosphor-icons/react";

function CategoryModalGridItemsSection({ modalData, formData, numberOfColumns, getEmptyRow, mapRow }) {
  const { editData } = modalData;
  const { fields, append, remove } = formData;

  return (
    <>
      {fields.map((row, index) => {
        const gridItems = [];

        gridItems.push(...mapRow(row, index));

        // Adding row removal button if it is not edit modal
        if (!editData) {
          gridItems.push(<IconButton
            type="button"
            icon={<Trash size={18} />}
            variant="ghost"
            color="gray.500"
            _hover={{ color: "red.500" }}
            disabled={fields.length === 1}
            aria-label="Remove row"
            onClick={() => {
              remove(index);
            }}
          />);
        }

        return gridItems.map((gridItem, gridItemIndex) => {
          // To the number of columns we add one action column (if it's not in edit mode)
          const totalNumberOfColumns = numberOfColumns + (editData ? 0 : 1);

          return <GridItem
            key={`category-modal-item-${gridItemIndex}`}
            px={4}
            py={2}
            display="flex"
            alignItems="center"
            borderBottom="1px solid"
            borderColor="gray.100"
            colSpan={editData ? 2 : gridItemIndex === totalNumberOfColumns - 1 ? 1 : 2}
          >
            {gridItem}
          </GridItem>;
        });
      })}

      {/* Last grid item (row) is spanning over all the columns and this is how we calculate it. */}
      {/* We have 1 column (the action column) with colSpan = 1, and all other columns have colSpan = 2 */}
      {!editData && <GridItem
        colSpan={(numberOfColumns * 2) + 1}
        px={4}
        py={3}
        display="flex"
        alignItems="center"
        bg="lightLime"
        cursor="pointer"
        onClick={() => {
          append(getEmptyRow(), { shouldFocus: false });
        }}
        _hover={{ bg: "limeShade.50" }}
      >
        <Text fontSize="14px" fontWeight="600" color="limeShade.700">
          + {t("buttons.addAnotherItem")}
        </Text>
      </GridItem>}
    </>
  );
}

export default CategoryModalGridItemsSection;
